module.exports = __webpack_public_path__ + "img/progress_013.34433c02.png";